import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { mySubscriptionProducts, updateSubscriptionDetails } from "@TKCCP/Services/tkccpSubscriptionProductsService";
import { CustomApiHandler } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SubscriptionProductIsSelected } from "@TKCCP/Types/ApiModels";

type updateSubscriptionParameter = {
    Id: string;
    Name: string;
    UserProfileId: string;
    CustomerId: string;
    StartDate: string;
    EndDate: string | null;
    IsActive: boolean;
    NextOrderFrequencyInDays: string;
    SubscriptionProductsList: SubscriptionProductIsSelected[];
} & HasOnSuccess;

type HandlerType = CustomApiHandler<updateSubscriptionParameter, updateSubscriptionParameter, mySubscriptionProducts>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        Id: props.parameter.Id,
        Name: props.parameter.Name,
        UserProfileId: props.parameter.UserProfileId,
        CustomerId: props.parameter.CustomerId,
        StartDate: props.parameter.StartDate,
        EndDate: props.parameter.EndDate,
        IsActive: props.parameter.IsActive,
        NextOrderFrequencyInDays: props.parameter.NextOrderFrequencyInDays,
        SubscriptionProductsList: props.parameter.SubscriptionProductsList,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await updateSubscriptionDetails(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const DispatchInitalSubscriptionProduct: HandlerType = props => {
    props.dispatch({
        type: "Data/SubsriptionProductService/InitalValuesProduct",
    });
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback, DispatchInitalSubscriptionProduct];

const updateCreateSubscriptionForm = createHandlerChainRunner(chain, "updateCreateSubscriptionForm");
export default updateCreateSubscriptionForm;
